import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DocumentSearch } from "@models/document";

export interface InitialState {
  documentsSearch: DocumentSearch | undefined;
}

const initialState: InitialState = {
  documentsSearch: undefined,
};

export const browse = createSlice({
  name: "browse",
  initialState,
  reducers: {
    setDocumentsSearch: (state, action: PayloadAction<DocumentSearch | undefined>) => {
      state.documentsSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("logout", () => initialState);
  },
});

export const { setDocumentsSearch } = browse.actions;

export default browse.reducer;
